/**
 * 生产环境配置
 */

import { JavaOutlined } from "@ant-design/icons";
import { jsx } from "react/jsx-runtime";

const config = {
  // 应用基础路径，用于React Router的basename和资源加载路径前缀
  BASE_PATH: '/',
  
  // API基础URL，改为相对路径，使用代理模式
  API_BASE_URL: '/api',
  
  // SSE服务器基础URL
  API_BASE_URL2: '/ceoapi',
  
  // 应用版本
  VERSION: '0.1.0',
  
  // 默认欢迎语
  DEFAULT_WELCOME_MESSAGE: '欢迎使用CEO专属AI参谋长"小舵"，您可以提出战略方针、经营计划、组织架构、人才队伍、激励约束机制相关问题，我会进行深度分析后给出决策建议与风险预警。',
  
  
  // 文件上传配置
  FILE_UPLOAD: {
    MAX_SIZE: 50 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: [
      '.bmp', '.gif', '.jpg', '.jpeg', '.png', '.webp',
      '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
      '.html', '.htm', '.txt', '.md', '.markdown', '.pdf', '.csv'
    ],
    ALLOWED_MIME_TYPES: [
      'image/bmp', 'image/gif', 'image/jpeg', 'image/png', 'image/webp',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/html', 'text/plain', 'text/markdown', 'application/pdf', 'text/csv'
    ]
  },
  
  // UI设置
  UI_SETTINGS: {
    FILE_DISPLAY_MAX_NAME_LENGTH: 30,
    TOGGLE_PERSIST_KEY: 'chat_toggles',
    MAX_FILES_PER_MESSAGE: 10
  },
  
  // 模型图标映射
  MODEL_ICONS: {
    gpt4o: {
      backgroundColor: '#10a37f',
      backgroundImage: "url('https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/180px-ChatGPT_logo.svg.png')"
    },
    gpt4: {
      backgroundColor: '#10a37f',
      backgroundImage: "url('https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/180px-ChatGPT_logo.svg.png')"
    },
    claude: {
      backgroundColor: '#5436da',
      backgroundImage: "url('https://www.anthropic.com/images/favicon.svg')"
    },
    gemini: {
      backgroundColor: '#4285f4',
      backgroundImage: "url('https://www.gstatic.com/lamda/images/favicon_v1_70c82fa6c275ea3e26b1c73e12d4fe48.svg')"
    }
  }
};

export default config; 